import {
  applePayButtonRendered as applePayButtonRenderedOriginal,
  expressCheckoutWidgetButtonClicked as expressCheckoutWidgetButtonClickedOriginal,
  applePayMerchantValidationError as applePayMerchantValidationErrorOriginal,
  applePayMerchantValidationSucceeded as applePayMerchantValidationSucceededOriginal,
  applePayStartMerchantValidation as applePayStartMerchantValidationOriginal,
  applePayPaymentMethodSelected as applePayPaymentMethodSelectedOriginal,
  applePayPaymentAuthorized as applePayPaymentAuthorizedOriginal,
  applePayCallBackReceived as applePayCallBackReceivedOriginal,
  applePayShippingAddressNotAccepted as applePayShippingAddressNotAcceptedOriginal,
  paymentModalClosed as paymentModalClosedOriginal,
} from '@wix/bi-logger-payments-data/v2';
import {
  type applePayButtonRenderedParams as applePayButtonRenderedParamsOriginal,
  type expressCheckoutWidgetButtonClickedParams as expressCheckoutWidgetButtonClickedParamsOriginal,
  type applePayMerchantValidationErrorParams as applePayMerchantValidationErrorParamsOriginal,
  type applePayMerchantValidationSucceededParams as applePayMerchantValidationSucceededParamsOriginal,
  type applePayStartMerchantValidationParams as applePayStartMerchantValidationParamsOriginal,
  type applePayPaymentMethodSelectedParams as applePayPaymentMethodSelectedParamsOriginal,
  type applePayPaymentAuthorizedParams as applePayPaymentAuthorizedParamsOriginal,
  type applePayCallBackReceivedParams as applePayCallBackReceivedParamsOriginal,
  type applePayShippingAddressNotAcceptedParams as applePayShippingAddressNotAcceptedParamsOriginal,
  type paymentModalClosedParams as paymentModalClosedParamsOriginal,
} from '@wix/bi-logger-payments-data/v2/types';
import { type PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';

type ApplePayParams = {
  checkoutType: 'express';
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export type applePayButtonRenderedParams = applePayButtonRenderedParamsOriginal & ApplePayParams;

export const applePayButtonRendered: (
  p: applePayButtonRenderedParams,
) => ReturnType<typeof applePayButtonRenderedOriginal> = applePayButtonRenderedOriginal;

export type expressCheckoutWidgetButtonClickedParams = expressCheckoutWidgetButtonClickedParamsOriginal &
  ApplePayParams;

export const expressCheckoutWidgetButtonClicked: (
  p: expressCheckoutWidgetButtonClickedParams,
) => ReturnType<typeof expressCheckoutWidgetButtonClickedOriginal> = expressCheckoutWidgetButtonClickedOriginal;

export type applePayMerchantValidationErrorParams = applePayMerchantValidationErrorParamsOriginal & ApplePayParams;

export const applePayMerchantValidationError: (
  p: applePayMerchantValidationErrorParams,
) => ReturnType<typeof applePayMerchantValidationErrorOriginal> = applePayMerchantValidationErrorOriginal;

export type applePayMerchantValidationSucceededParams = applePayMerchantValidationSucceededParamsOriginal &
  ApplePayParams;

export const applePayMerchantValidationSucceeded: (
  p: applePayMerchantValidationSucceededParams,
) => ReturnType<typeof applePayMerchantValidationSucceededOriginal> = applePayMerchantValidationSucceededOriginal;

export type applePayStartMerchantValidationParams = applePayStartMerchantValidationParamsOriginal & ApplePayParams;

export const applePayStartMerchantValidation: (
  p: applePayStartMerchantValidationParams,
) => ReturnType<typeof applePayStartMerchantValidationOriginal> = applePayStartMerchantValidationOriginal;

export type applePayPaymentAuthorizedParams = applePayPaymentAuthorizedParamsOriginal & ApplePayParams;

export const applePayPaymentAuthorized: (
  p: applePayPaymentAuthorizedParams,
) => ReturnType<typeof applePayPaymentAuthorizedOriginal> = applePayPaymentAuthorizedOriginal;

export type applePayCallBackReceivedParams = applePayCallBackReceivedParamsOriginal & ApplePayParams;

export const applePayCallBackReceived: (
  p: applePayCallBackReceivedParams,
) => ReturnType<typeof applePayCallBackReceivedOriginal> = applePayCallBackReceivedOriginal;

export type applePayShippingAddressNotAcceptedParams = applePayShippingAddressNotAcceptedParamsOriginal &
  Omit<ApplePayParams, 'paymentmethod'> & {
    paymentMethod: PaymentMethod.ApplePay;
  };

export const applePayShippingAddressNotAccepted: (
  p: applePayShippingAddressNotAcceptedParams,
) => ReturnType<typeof applePayShippingAddressNotAcceptedOriginal> = applePayShippingAddressNotAcceptedOriginal;

export const paymentModalClosed: (
  p: paymentModalClosedParamsOriginal,
) => ReturnType<typeof paymentModalClosedOriginal> = paymentModalClosedOriginal;

export type applePayPaymentMethodChangedParams = applePayPaymentMethodSelectedParamsOriginal & ApplePayParams;

export const paymentMethodSelected: (
  p: applePayPaymentMethodChangedParams,
) => ReturnType<typeof applePayPaymentMethodSelectedOriginal> = applePayPaymentMethodSelectedOriginal;
